import { render, staticRenderFns } from "./bTabs.vue?vue&type=template&id=c8378be4&"
import script from "./bTabs.vue?vue&type=script&lang=js&"
export * from "./bTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports